import { safeParseJSON } from "@jti/fe-common";
export const extractVideoMetadata = (itemVideoContent) => {
    const metadata = {
        autoPlay: false,
    };
    if (!itemVideoContent?.videoMetadata) {
        return metadata;
    }
    const parsedMetadata = safeParseJSON(itemVideoContent.videoMetadata);
    metadata.autoPlay = Number(parsedMetadata?.auto_play || 0) === 1;
    return metadata;
};
//# sourceMappingURL=extractVideoMetadata.js.map